;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "gFSoVjhwy7"							}), success: c, error: e});						}, cb  = function(section, $) {/*---start js vendors---*/;var cb  = function($) {
  var _this = jQuery(this),
      list  = _this.find('.lh-blog-list'),
      count = _this.find('.lh-count');
  _this.find('.lh-item-title.active a');
  _this.find('.lh-item-title a').click(function(){
    var __this = $(this);
    if(!__this.hasClass('active')){
      __this.parent().addClass('active').siblings('.active').removeClass('active');
      setActiveCate(__this);
    }

  })
  function setActiveCate($this) {
    var target = $this.data('value'),
        e_target = _this.find('.lh-item-blog[data-handle="'+target+'"]');
    if(e_target){
      list.css('transform','translateX(-'+(e_target.index()*100)+'%)');
      count.text(e_target.data('count'));
    }
  }
 };						cb.bind($('section[data-section-id="gFSoVjhwy7"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="gFSoVjhwy7"]').get(0))({						url: "https://dev.layouthub.com/DEV-TEAMWORK/TEAMWORK/le-vi/ozzy-blog-list_79/Ozzy_Blog/blog/",						settings: {}					}, jQuery);})(jQuery);